import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyLogin } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        applyLogin(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/app", { replace: true, state: { user: data.user } });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    })();
  }, [applyLogin, navigate]);
  return <div className="min-h-screen grid place-items-center ink"><div className="fade-up flex flex-col items-center gap-4"><Logo dark size={44} /><p className="text-white/60 text-sm">Verificando tu sesión…</p></div></div>;
}
